export const allowOnlyDecimals = (value: string) => {
    let input = value.replace(/[^\d,]/g, "");
    const [integer, ...decimals] = input.split(",");
    if (decimals.length) {
        input = `${integer},${decimals.join("")}`;
    }

    return input;
}